export enum ModuleName {
  Transaction = 1,
  Customer = 2,
  PaymentAccount = 3,
  Invoice = 4,
  Product = 5,
  PaymentPlan = 6,
  Partner = 7,
  TermsAndCondition = 8,
  Report = 9,
  PaymentLink = 10,
  AccountToken = 11,
  TokenLink = 12,
  CBNacha = 13,
  PremiumFinance = 14,
  TransactionRefund = 15,
  TransactionVoid = 16,
  TransactionChargeback = 17,
  MerchantManagement = 18,
  AccountPayout = 19,
  OutboundPayment = 20,
  Merchant = 21,
  PayoutCapability = 22
}

export enum ModuleNameMapping {
  Transaction = 'Transaction',
  Customer = 'Customer',
  PaymentAccount = 'Payment Account',
  Invoice = 'Invoice',
  Product = 'Product',
  PaymentPlan = 'Payment Plan',
  Partner = 'Partner',
  TermsAndCondition = 'Terms and Condition',
  Report = 'Report',
  PaymentLink = 'Payment Link',
  AccountToken = 'Account Token',
  TokenLink = 'Token Link',
  CBNacha = 'CBNacha',
  PremiumFinance = 'Premium Finance',
  TransactionRefund = 'Refund',
  TransactionVoid = 'Void',
  TransactionChargeback = 'Chargeback',
  MerchantManagement = 'Merchant Management',
  AccountPayout = 'Account Payout',
  OutboundPayment = 'Outbound Payment',
  Merchant = 'Merchant',
  PayoutCapability = 'Payout Capability',
}

export enum AuthType {
    NoAuth = 1,
    ApiKey = 2,
    BearerToken = 3,
    BasicAuth = 4
}
